module.exports = __webpack_public_path__ + "f574cf7d25f1a81d9dc8dc097d15c8b8.png";